import { Button, cn } from "kz-ui-sdk";
import { useTranslation } from "react-i18next";
import styles from "../SkinnerBoxFAB.module.css";

interface SkinnerBoxActionsProps {
  showClaim: boolean;
  onClaimClick: () => void;
  isLoading?: boolean;
  zIndex: number;
}

const SkinnerBoxActions = ({ showClaim, onClaimClick, isLoading = false, zIndex }: SkinnerBoxActionsProps) => {
  const { t } = useTranslation();

  if (!showClaim) {
    return (
      <span
        className={cn(
          "pointer-events-none absolute left-1/2 h-[16px] w-[64px] shrink-0 -translate-x-1/2 text-center",
          styles.bonusText,
        )}
        style={{ position: "absolute", bottom: "28px", zIndex }}
      >
        {t("bonus")}
      </span>
    );
  }

  return (
    <div
      className="absolute left-1/2 -translate-x-1/2"
      style={{ bottom: "16px", zIndex }}
    >
      <span className="relative ml-1 inline-block">
        <Button
          size="sm"
          variant="primary"
          className="px-3 py-0"
          shiny
          aria-label="Claim Skinner Box"
          onClick={(e) => {
            e.stopPropagation();
            onClaimClick();
          }}
          loading={isLoading}
          classes={{
            "root&": "min-w-[70px] disabled:!bg-grdPrimary disabled:!opacity-100",
            "label&": "text-[14px] leading-[14px]  whitespace-nowrap",
          }}
          style={{
            paddingTop: 0,
            paddingBottom: 0,
            height: 20,
          }}
        >
          {t("prizes claim")}
        </Button>
      </span>
    </div>
  );
};

export default SkinnerBoxActions;
